"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    borderRadius: '3px',
    textTransform: 'none',
    fontFamily: _theme.default.typography.proxima.regular,
    textRendering: 'geometricPrecision'
  },
  toolbar: {
    minHeight: 'auto',
    paddingRight: '0'
  },
  caption: {
    fontFamily: _theme.default.typography.proxima.regular,
    fontSize: '16px'
  },
  actions: {
    color: '#005EDC',
    marginLeft: '10px',
    '& button': {
      padding: '0 10px 0 10px',
      '&:hover, &:focus, &:active': {
        boxShadow: 'none',
        backgroundColor: 'transparent'
      },
      '& svg': {
        fontSize: '32px'
      }
    }
  }
});
var _default = exports.default = useStyles;